<template>
  <cms-section
    :first-section="firstElement"
    page-context
    :section="{ name: 'filter-by', items }"
  />
</template>

<script setup lang="ts">
import type { FilterBy } from '#types/components/cms/filter-by'

const { content } = defineProps<{
  content: { filters: FilterBy[] }
  firstElement?: boolean
}>()

const route = useRoute()

const { filters } = content

const items = computed(() => filterContentBy(filters, route))
</script>
